import React, { useState, useEffect } from "react";
import style from "./duplicatedPeople.scss";
import { Button, Col, Row, ButtonGroup } from "reactstrap";
import { showToast } from "../../../../../utils/Helper";

const DuplicatedPeople = ({ alert, fetchs, Link,closeAlert }) => {
  const [duplicatedPeople, setDuplicatedPeople] = useState([]);
  const [loading, setLoading] = useState(false);
  const [personFromPershing, setPersonFromPershing] = useState(null);
  const [personFromSystem, setPersonFromSystem] = useState(null);
  const [personFromPershingFullName, setPersonFromPershingFullName] = useState(null);
  const [personFromSystemFullName, setPersonFromSystemFullName] = useState(null);
  const [matchingFields, setMatchingFields] = useState([]);
  const [merging, setMerging] = useState(false);
  const [equalDocumentType, setEqualDocumentType] = useState(false);
  const [personToKeep, setPersonToKeep] = useState(null);
  const [personToMerge, setPersonToMerge] = useState(null);

  useEffect(() => {
    setLoading(true);
    fetchs.clientInfo({ personId: alert.personId }, (r) => {
      setPersonFromPershing(r.personInfo);
    });
    fetchs.clientInfo({ personId: alert.refId }, (r) => {
      setPersonFromSystem(r.personInfo);
    });
    setLoading(false);
  }, [alert.personId, alert.refId]);

  useEffect(() => {
    if (personFromPershing) {
      setPersonFromPershingFullName(
        personFromPershing.PhysicalPersonFirstName + " " + personFromPershing.PhysicalPersonFirstLastName
      );
    }
  }, [personFromPershing]);

  useEffect(() => {
    if (personFromPershing && personFromSystem) {
      setMatchingFields(getMatchingFields(personFromPershing, personFromSystem));
      checkSameDocumentType(personFromPershing, personFromSystem);
      //load defaults
      setPersonToKeep(personFromSystem.PersonId);
      setPersonToMerge(personFromPershing.PersonId);
    }
  }, [personFromPershing, personFromSystem]);

  const merge = () => {
    setMerging(true);
    fetchs.mergePeople({ personToMergeId: personToMerge, personToKeepId: personToKeep }, (r) => {
      if (r) {
        showToast("success: People merged successfully");
        closeAlert();
      }
      setMerging(false);
    });
  };

  const checkSameDocumentType = (personFromPershing, personFromSystem) => {
    personFromPershing.Documents.forEach((docPershing) => {
      personFromSystem.Documents.forEach((docSystem) => {
        if (
          docPershing.PersonDocumentIssueCountryId === docSystem.PersonDocumentIssueCountryId &&
          docPershing.PersonDocumentTypeId === docSystem.PersonDocumentTypeId
        ) {
          setEqualDocumentType(true);
        }
      });
    });
  };

  const getMatchingFields = (personFromPershing, personFromSystem) => {
    const matchingFields = [];
    for (const key in personFromPershing) {
      if (personFromPershing[key] === personFromSystem[key]) {
        if (personFromPershing[key] && personFromPershing[key] != 0 && personFromPershing[key] != "") {
          if (key.includes("Date")) {
            if (!personFromPershing[key].includes("0000-00-00")) {
              matchingFields.push(key);
            }
          } else {
            matchingFields.push(key);
          }
        }
      }
    }
    return matchingFields;
  };

  useEffect(() => {
    if (personFromSystem) {
      setPersonFromSystemFullName(
        personFromSystem.PhysicalPersonFirstName + " " + personFromSystem.PhysicalPersonFirstLastName
      );
    }
  }, [personFromSystem]);

  return (
    <div>
      {!personFromPershing || !personFromSystem ? (
        <div>Loading...</div>
      ) : (
        <div className="container">
          <Link to={`/person/${alert.personId}`} target="_blank">
            {`${personFromPershing.PhysicalPersonFirstName+' '+personFromPershing.PhysicalPersonFirstLastName}(${
              personFromPershing.PhysicalPersonMainDocumentNumber
                ? personFromPershing.PhysicalPersonMainDocumentNumber
                : typeAlias
            })- from pershing`}
          </Link>
          <br />
          <Link to={`/person/${alert.refId}`} target="_blank">
            {`${personFromSystem.PhysicalPersonFirstName+' '+personFromSystem.PhysicalPersonFirstLastName}(${
              personFromSystem.PhysicalPersonMainDocumentNumber
                ? personFromSystem.PhysicalPersonMainDocumentNumber
                : typeAlias
            })- from system`}
          </Link>
          <br />
          <br />
          <h4>Matching Fields</h4>
          <div style={{ maxHeight: "20vh", overflowY: "auto" }}>
            <ul>
              {matchingFields.map((field, i) => (
                <li key={i}>{field}</li>
              ))}
            </ul>
          </div>
          <br />
          <Row style={{ marginBottom: "7px" }}>
            <Col lg={10}>
              <p style={{ marginBottom: "10px" }}>
                Do you want to merge the pershing person with the system person?
              </p>
            </Col>
            <Col lg={2}>
              <Button label onClick={() => merge()} color={"primary"} size="sm">
                {merging ? <i class="fa fa-spinner fa-pulse fa-fw"></i> : <i>Merge</i>}
              </Button>
            </Col>
            <Col>
              <p>Choose the person you want to keep</p>
              <ButtonGroup>
                <Button
                  color={personToKeep == personFromPershing.PersonId ? "primary" : "secondary"}
                  onClick={() => {
                    setPersonToKeep(personFromPershing.PersonId);
                    setPersonToMerge(personFromSystem.PersonId);
                  }}
                  size="sm"
                >
                  {`${personFromPershingFullName}(${
                    personFromPershing.PhysicalPersonMainDocumentNumber
                      ? personFromPershing.PhysicalPersonMainDocumentNumber
                      : typeAlias
                  })`}
                </Button>
                <Button
                  color={personToKeep == personFromSystem.PersonId ? "primary" : "secondary"}
                  onClick={() => {
                    setPersonToKeep(personFromSystem.PersonId);
                    setPersonToMerge(personFromPershing.PersonId);
                  }}
                  size="sm"
                >
                  {`${personFromSystemFullName}(${
                    personFromSystem.PhysicalPersonMainDocumentNumber
                      ? personFromSystem.PhysicalPersonMainDocumentNumber
                      : typeAlias
                  })`}
                </Button>
              </ButtonGroup>
            </Col>
            <Col lg={12} style={{marginTop:'5px'}}>
              {equalDocumentType ? (
                <p style={{ color: "red" }}>
                  The documents have the same type and country, you need to fix it in the original system,
                  otherwise the alert will be regenerated
                </p>
              ) : (
                <div></div>
              )}
            </Col>
          </Row>
        </div>
      )}
    </div>
  );
};

export default DuplicatedPeople;
